import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../Utils/Patient";

const generatePDF = async (data) => {
  console.log("comingPDF", data);

  pdfMake.fonts = {
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  let name_regime = "";
  switch (parseInt(data.regime)) {
    case 1:
      name_regime = "PARTICULAR";
      break;
    case 2:
      name_regime = "SUBSIDIADO";
      break;
    case 3:
      name_regime = "CONTRIBUTIVO";
      break;
    case 4:
      name_regime = "REGIMEN ESPECIAL";
      break;
    case 5:
      name_regime = "CONTRIBUTIVO COMPLEMENTARIO";
      break;
    case 6:
      name_regime = "SOAT";
      break;
    case 7:
      name_regime = "POLIZA";
      break;
    case 8:
      name_regime ="PARTICULAR MEDICINA PREPAGADA";
      break;
    case 9:
      name_regime = "OTROS";
      break;
    default:
      name_regime = "";
      break;
  }

  let tableDiagnostics = [];

  tableDiagnostics.push(
    [{ text: 'Diagnóstico CIE-10 ', bold: true, fontSize: 10 }, { text: 'Nombre', bold: true, fontSize: 10 }, { text: 'Observación', bold: true, fontSize: 10 }],
  );

  try {
    for (let k = 0; k < data.diagnosticCIE10.length; k++) {
      const element = data.diagnosticCIE10[k];
      tableDiagnostics.push([
        { text: element.codigo, style: 'textStyle' }, { text: element.nombre, style: 'textStyle' }, { text: element.observacion, style: 'textStyle' }
      ])
    }
  } catch (error) {
    console.log(error)
  }

  const fecha = data.today;
  const name =
    data.typeOfDocument + "-" + data.documentNumber + " " + data.fullname;

  let tableBody = [];
  tableBody[0] = [
    { text: "Clase de Documento ", style: "textStyle", bold: true },
    { text: "Fecha ", style: "textStyle", bold: true },
    { text: "	Descripción", style: "textStyle", bold: true },
    { text: "Nombre", style: "textStyle", bold: true },
  ];

  for (let i = 0; i < data.documents.length; i++) {
    tableBody[i + 1] = [
      { text: data.documents[i].clase, style: "textStyle" },
      { text: data.documents[i].fecha, style: "textStyle" },
      { text: data.documents[i].descripcion, style: "textStyle" },
      { text: data.documents[i].nombre, style: "textStyle" },
    ];
  }

  let tableBodyRadipharmacyDosse = [];
  tableBodyRadipharmacyDosse[0] = [
    { text: "Nombre del Medicamento", style: "textStyle", bold: true },
    { text: "Fecha de Aplicación", style: "textStyle", bold: true },
    { text: "Dosis", style: "textStyle", bold: true },
    { text: "Observación", style: "textStyle", bold: true },
  ];

  for (let i = 0; i < data.radioPharmacyList.length; i++) {
    tableBodyRadipharmacyDosse[i + 1] = [
      {
        text: data.radioPharmacyList[i].nombre_medicamento,
        style: "textStyle",
      },
      {
        text:
          data.radioPharmacyList[i].fecha_aplicacion != null
            ? moment(data.radioPharmacyList[i].fecha_aplicacion).format(
              "DD/MM/YYYY"
            )
            : "",
        style: "textStyle",
      },
      { text: data.radioPharmacyList[i].dosis, style: "textStyle" },
      { text: data.radioPharmacyList[i].observacion, style: "textStyle" },
    ];
  }

  const services = [];

  for (let obj of data.services) {
    services.push([
      { text: "CUPS " + obj.codigo, style: "textStyle", bold: true },
      { text: obj.nombre, style: "textStyle", bold: true },
    ]);
  }

  let urlServe =
    process.env.REACT_APP_PUBLIC_URL +
    "profesional/ver-firma/" +
    data.id_Professional +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma = "";

  let urlServe2 =
    process.env.REACT_APP_PUBLIC_URL +
    "usuario/" +
    data.tecnologo?.id_usuario +
    "/" +
    data.tecnologo?.firma +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma2 = "";

  let urlFirma3 = ""; // Paciente

  let test = fetch(urlServe).then((response) => {
    if (response.status === 500) {
      return false;
    } else {
      return true;
    }
  });

  let test2 = fetch(urlServe2).then((response) => {
    if (response.status === 404 || response.status === 500) {
      return false;
    } else {
      return true;
    }
  })


  let test3 = fetch(data.urlSiganturePatient).then((response) => {
    if (response.status === 404 || response.status === 500) {
      return false;
    } else {
      return true;
    }
  });

  let isImg = await test;

  let isImg2 = await test2;

  let isImg3 = await test3;

  if (isImg) {
    urlFirma = urlServe;
  } else {
    urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  if (isImg2) {
    urlFirma2 = urlServe2;
  } else {
    urlFirma2 = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  if (isImg3 && data.urlSiganturePatient !== null && data.urlSiganturePatient !== undefined) {
    urlFirma3 = data.urlSiganturePatient;
  } else {
    urlFirma3 = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  const header = {
    margin: [40, 10, 0, 10],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getBase64ImageFromURL(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\n  NIT" +
              data.profile.nit +
              "\n Dirección: " +
              data.profile.direccion.direccion +
              " Teléfono:" +
              data.profile.telefono1,
            style: "head",
          },
        ],
      ],
    },
  };

  const personalData = [
    [
      { text: "Nombre ", bold: true, style: "textStyle" },
      { text: data.fullname, style: "textStyle" },
      { text: "Identificación", bold: true, style: "textStyle" },
      { text: data.typeOfDocument + ' ' + data.documentNumber, style: "textStyle" },
      { text: "Admisión No.", bold: true, style: "textStyle" },
      { text: data.id_admision, style: "textStyle" },
    ],
    [
      { text: "Fecha Nac.", bold: true, style: "textStyle" },
      { text: moment(data.birthday).format("DD/MM/YYYY"), style: "textStyle" },
      { text: "Edad ", bold: true, style: "textStyle" },
      { text: calculateAgeParse(data.birthday), style: "textStyle" },
      { text: "Genero", bold: true, style: "textStyle" },
      { text: data.gender, style: "textStyle" },
    ],
    [
      { text: "Peso ", bold: true, style: "textStyle" },
      { text: data.peso !== null ? data.peso + " kg" : "", style: "textStyle" },
      { text: "Talla ", bold: true, style: "textStyle" },
      {
        text: data.talla !== null ? data.talla + " cm" : "",
        style: "textStyle",
      },
      { text: "Celular ", bold: true, style: "textStyle" },
      { text: data.cellphone, style: "textStyle" },
    ],
    [
      { text: "Dirección ", bold: true, style: "textStyle" },
      { text: data.address, style: "textStyle" },
      { text: "Municipio ", bold: true, style: "textStyle" },
      { text: data.city, style: "textStyle" },
      { text: "Fecha Proc.", bold: true, style: "textStyle" },
      { text: moment(data.date).format("DD/MM/YYYY"), style: "textStyle" },
    ],
    [
      { text: "Entidad ", bold: true, style: "textStyle" },
      { text: data.third.nit + " " + data.third.nombre, style: "textStyle" },
      { text: "Regimen ", bold: true, style: "textStyle" },
      { text: name_regime, style: "textStyle" },
      { text: "Creatinina ", bold: true, style: "textStyle" },
      { text: data.diagnostic.creatinina, style: "textStyle" },
    ],
    [
      { text: "Medico Remitente ", bold: true, style: "textStyle" },
      { text: data.remitente, style: "textStyle" },
      "",
      "",
      "",
      "",
    ],
  ];

  const signatures = [
    {
      // auto-sized columns have their widths based on their content
      unbreakable: true,
      margin: [10, 40, 10, 0],
      layout: "headerLineOnly",
      table: {
        widths: [130],
        headerRows: 1,
        body: [
          [
            {
              image: await getBase64ImageFromURL(urlFirma3),
              fit: [100, 100],
            },
          ],
          [{ text: "Paciente", style: "signature" }],
          [
            {
              text: data.fullname !== undefined ? data.fullname : null,
              style: "signature",
            },
          ],
        ],
      },
    },
    {
      // auto-sized columns have their widths based on their content
      unbreakable: true,
      margin: [10, 40, 10, 0],
      layout: "headerLineOnly",
      table: {
        widths: [130],
        headerRows: 1,
        body: [
          [
            {
              image: await getBase64ImageFromURL(urlFirma),
              fit: [100, 100],
            },
          ],
          [{ text: "Médico", style: "signature" }],
          [
            {
              text:
                data.professional.nombres !== undefined &&
                  data.professional.apellido1 !== undefined
                  ? data.professional.nombres +
                  " " +
                  data.professional.apellido1
                  : null,
              style: "signature",
            },
          ],
        ],
      },
    },
    {
      // auto-sized columns have their widths based on their content
      unbreakable: true,
      margin: [10, 40, 10, 0],
      layout: "headerLineOnly",
      table: {
        widths: [130],
        headerRows: 1,
        body: [
          [
            {
              image: await getBase64ImageFromURL(urlFirma2),
              fit: [100, 100],
            },
          ],
          [{ text: "Técnologo", style: "signature" }],
          [
            {
              text:
                data.tecnologo.nombres !== undefined &&
                  data.tecnologo.apellido1 !== undefined
                  ? data.tecnologo.nombres + " " + data.tecnologo.apellido1
                  : "",
              style: "signature",
            },
          ],
        ],
      },
    },
  ];

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              { text: name, style: "head" },
              {
                text:
                  "Fecha Impresión: " +
                  data.today,
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [25, 0, 0, 5],
      };
    },
    content: [
      {
        margin: [0, 10, 0, 0],
        table: {
          headerRows: 1,
          widths: [520],
          body: [[""], [""]],
        },
        layout: "headerLineOnly",
      },
      {
        unbreakable: true,
        margin: [0, 0, 0, 0],
        layout: "noBorders",
        table: {
          widths: ["auto", "*", "auto", "*", "auto", "*"],
          body: personalData,
        },
      },
      {
        margin: [0, 0, 0, 10],
        table: {
          headerRows: 1,
          widths: [520],
          body: [[""], [""]],
        },
        layout: "headerLineOnly",
      },
      {
        margin: [0, 0, 0, 10],
        layout: "noBorders",
        table: {
          headerRows: 1,
          widths: ["auto", "*"],
          body: services,
        },
      },
      data.diagnosticCIE10.length > 0 && data.diagnosticCIE10 !== null && data.diagnosticCIE10 !== undefined ?
        {
          unbreakable: true,
          margin: [0, 5, 0, 10],
          layout: data.diagnosticCIE10.length === 0 ? 'noBorders' : 'headerLineOnly',
          table: {
            widths: ['auto', '*', '*'],
            headerRows: 1,
            body: tableDiagnostics,
          },
        }
        : null,
      data.radioPharmacyList.length > 0
        ? {
          text: "Aplicación de Medicamentos ",
          style: "tableheader",
        }
        : null,
      data.radioPharmacyList.length > 0
        ? {
          margin: [0, 10, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ["*", "*", "*", "*"],
            headerRows: 1,
            body: tableBodyRadipharmacyDosse,
          },
        }
        : null,
      data.impresions !== ""
        ? {
          margin: [0, 10, 0, 5],
          text: "Impresión Diagnostica ",
          style: "tableheader",
        }
        : null,
      data.impresions !== ""
        ? {
          margin: [0, 0, 0, 10],
          text: data.impresions,
          style: "textStyle",
        }
        : null,
      data.documents.length > 0
        ? {
          text: "Estudios Anteriores ",
          style: "tableheader",
        }
        : null,

      data.documents.length > 0
        ? {
          margin: [0, 10, 0, 10],
          layout: "headerLineOnly",
          table: {
            widths: ['auto', 50, "*", 120],
            headerRows: 1,
            body: tableBody,
          },
        }
        : null,
      data.observations !== ""
        ? [
          {
            margin: [0, 10, 0, 5],
            text: "Observaciones ",
            style: "tableheader",
          },
          {
            margin: [0, 0, 0, 10],
            text: data.observations,
            style: "textStyle",
          },
        ]
        : null,
      {
        unbreakable: true,
        margin: [0, 0, 0, 0],
        layout: "noBorders",
        table: {
          widths: ["auto", "*", "auto", "*", "auto", "*"],
          body: personalData,
        },
      },
      {
        margin: [0, 2, 0, 5],
        text: "Diagnosticos de Ingreso: ",
        style: "tableheader",
      },
      {
        margin: [0, 5],
        columns: [
          {
            width: "*",
            text: "Alergias ( " + data.diagnostic.alergia + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Asma  (  " + data.diagnostic.asma + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Marca Paso (  " + data.diagnostic.marcapaso + " )",
            style: "textStyle",
          },
        ],
      },
      {
        margin: [0, 5],
        columns: [
          {
            width: "*",
            text: "Implante ( " + data.diagnostic.implante + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Protesis  ( " + data.diagnostic.protesis + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Bomba Infusion ( " + data.diagnostic.bomba + " )",
            style: "textStyle",
          },
        ],
      },
      {
        margin: [0, 5],
        columns: [
          {
            width: "*",
            text: "Operado   ( " + data.diagnostic.operado + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Embarazo  ( " + data.diagnostic.embarazo + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "Puentes Dentales  ( " + data.diagnostic.puentes + " )",
            style: "textStyle",
          },
        ],
      },
      {
        margin: [0, 5],
        columns: [
          {
            width: "*",
            text: "Objetos Metalicos ( " + data.diagnostic.objetos + " )",
            style: "textStyle",
          },
          {
            width: "*",
            text: "",
            style: "textStyle",
          },
          {
            width: "*",
            text: "",
            style: "textStyle",
          },
        ],
      },
      {
        margin: [0, 10, 0, 5],
        text:
          data.diagnostic.otrosText !== ""
            ? "Antecedentes Registro Clínico: \n " + data.diagnostic.otrosText
            : "",
        style: "textStyle",
      },
      {
        // auto-sized columns have their widths based on their content
        columns: signatures,
        columnGap: 10,
      },
    ],
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 9,
      },
      signature: {
        fontSize: 8,
        alignment: "center",
        bold: true,
      },
      foter: {
        margin: 10,
        fontSize: 6,
      },
      medicStyle: {
        margin: [0, 80, 0, 0],
        fontSize: 10,
        alignment: "left",
      },
    },
  };

  pdfMake.createPdf(documentDefinition).open();
};

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
}

export default generatePDF;
